import ClaimsPaymentsTable from 'components/features/claims-payments-table';
import HomeLayout from 'layouts/home-layout';
import { useTranslation } from 'react-i18next';

function ClaimsPaymentsDashboard() {
  const { t } = useTranslation();

  return (
    <HomeLayout title={t('sidebar.claimsPaymentsDashboard')}>
      <div className="bg-[#E3F2FB] p-[10px] rounded-lg my-[20px]">
        <ClaimsPaymentsTable />
      </div>
    </HomeLayout>
  );
}

export default ClaimsPaymentsDashboard;
